export const API_KEY = 'AIzaSyDWuT_jfBPMqVnv7UreiAIluw2PttzE0hA'
export const AUTH_DOMAIN = 'attendix-demo.firebaseapp.com'
export const DATABASE_URL = 'https://attendix-demo.firebaseio.com'
export const PROJECT_ID = 'attendix-demo'
export const STORAGE_BUCKET = 'attendix-demo.appspot.com'
export const MESSAGING_SENDER_ID = '66819544199'

export const config = {
  apiKey: API_KEY,
  authDomain: AUTH_DOMAIN,
  databaseURL: DATABASE_URL,
  projectId: PROJECT_ID,
  storageBucket: STORAGE_BUCKET,
  messagingSenderId: MESSAGING_SENDER_ID
}

export default config



// WEBPACK FOOTER //
// ./src/constants/firebase.js